/* The selection bar sits in the ghost bar's row, so it shares its frame (Joni's layout, 2026-10-31) */
.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-md);
}

/* The deterministic actions, the left-hand group */
.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.reason {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
}

/* Exact intervals is a mode: while it is on, it shows, and its ✕ turns it off */
.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  padding-left: var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-pill);
  font-size: var(--tuna-typography-caption-fontSize);
}

/* Keep going (M7.2), the AI source: at the right end, set off by a divider, before More actions */
.keepGoing {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  padding-left: var(--tuna-spacing-1);
  border-left: 1px solid var(--tuna-border-default);
}

/* Spec §9: 44px targets on a phone */
@media (max-width: 599.95px) {
  .bar button {
    min-width: 44px;
    min-height: 44px;
  }

  /* Joni's #3038 review: in a phone's sheet, the reason caption goes under Keep going rather than beside it */
  .keepGoing {
    flex-wrap: wrap;
  }
}
